import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Image, Form, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import axios from 'axios';
import renderHTML from 'react-render-html';
import AlertContainer from 'react-alert';
import { reduxForm } from 'redux-form/immutable';
import moment from 'moment';
import cleanArray from 'clean-array';
import {
  getCampaignQuestion,
  updateCampaignCount,
  getUserDetails,
  deleteS3Video,
} from '../../redux/modules/splash';
import { updateSignaturePic } from '../../redux/modules/splash';
import { updateCampaignFilter } from '../../redux/modules/campaign';
import { getUserPreferences } from '../../redux/modules/settings';
import { savePlugins, getPluginsByUserId } from '../../redux/modules/plugins';
import config from '../../config';
import './style.css';
import { Images } from '../../style';
import {
  getQueryParams,
  getContrast,
} from '../../helpers/commonHelper';
import { CAMPAIGN_COLOR, COLORS, CAMPAIGN_TYPE_VALUE, VIDEO_SUBMISSION_TYPE } from "../../constants";
import campaignImage from '../Campaign/campImage.jpg';
import '../../../node_modules/video-react/dist/video-react.css';
import assetsUrl from '../../utils/assetsUrl';
import ReactGA from 'react-ga';
import { isRecordingSupported } from '../../helpers/supportedFeatureHelper';
import { extractComplete } from '../../utils/extractBrowserInfo';

import {
  Accordion,
  BoundaryWarning,
  CampaignForm,
  SignatureArea,
  TermsArea,
  Video,
  Submission,
  AlertModal,
  RecordNotSupportedMessage,
} from '../../components';
import Footer from '../../components/Footer/Footer';
import LogoRow from './Logo';
import APP_ROUTES from '@src/app_routes';

const getOriginalImg = (path) => path.replace('optimized', 'original');

const isPreview = search => search ? search.includes('preview=true') : false;

// We need to know specifically if this is an iPad because we only want to show a single button
// // like a mobile device but we also don't want to show the Safari message. iPads now spoof their UA so that
// they get the desktop experience so it is hard for us to pinpoint exactly which device the user is on.
const isIPad = (window.navigator && navigator.userAgent.match(/(iPad)/) /* iOS pre 13 */ ||
    (window.navigator && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) /* iPad OS 13 */);

const publicIp = require('react-public-ip');
let HtmlToReactParser = require('html-to-react').Parser;
let htmlToReactParser = new HtmlToReactParser();

@reduxForm({
  form: "splash",
})
class Splash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questionDescription: false,
      questionId: "",
      description: "",
      activeIndex: 0,
      indexValue: "",
      uploadProgress: [],
      videosUploaded: [],
      isChecked: false,
      button: "",
      uploadFinish: [],
      processingVideo: false,
      fieldType: "hidden",
      companyName: "",
      jobTitle: "",
      country: "",
      covidResponseLink: "",
      engagementTier: 0,
      institutionName: "",
      fullName: "",
      email: "",
      phoneNumber: "",
      address: "",
      latitude: false,
      longitude: false,
      updateCount: true,
      progressArrow: [],
      inputFields: "",
      progressCount: 0,
      uploadCount: 0,
      videoDuration: [],
      videoDurationError: [],
      showError: false,
      ipAddress: "",
      selfie_photo: "",
      product_photo: "",
      socialMediaHandle: "",
      paypalOrVenmo: "",
      influencerFee: "",
      birthDate: "",
      signature_photo: "",
      uploadSignaturePhoto: false,
      showSignaturePad: false,
      changeButtonColor: false,
      videoSRC: "",
      videoChunks: [],
      isRecordOrUploadVideo: [],
      showAndHideVideo: [],
      startRecording: [],
      isWebCamOrNot: false,
      reRender: false,
      videoAutoPlay: false,
      showAndHidePlayButton: true,
      videoNotFound: false,
      nps: null,
      starRating: null,
      modalContent: null,
      modalIsVisible: false,
      isUploadInProgress: false,
    };

    this.uploader = [];
    this.uploadInput = [];
    this.videoPlayer = [];
    this.alertOptions = {
      offset: 14,
      position: "top left",
      theme: "light",
      time: 500000,
      transition: "scale",
    };
    this.processVideo = this.processVideo.bind(this);
    this.onUploadStart = this.onUploadStart.bind(this);
    this.campaignForm = React.createRef();
    this.isRecordingSupported = isRecordingSupported();
}

  static propTypes = {
    dispatch: PropTypes.func,
    CampaignDetails: PropTypes.object,
    errorMessage: PropTypes.object,
    handleSubmit: PropTypes.func,
  };

  componentWillMount = async () => {
    const { dispatch } = this.props;

    try {
      await dispatch(getCampaignQuestion(this.props.match.params.id));
      const {
        campaignQuestions,
        user_info_fields,
      } = this.props.CampaignDetails;

      if (campaignQuestions && campaignQuestions.length > 0) {
        const uploadProgress = [];
        campaignQuestions.forEach(() => {
          const formatedKey = {
            percent: "",
          };
          uploadProgress.push(formatedKey);
        });
        this.setState({ uploadProgress });
        const spiltInputFields = user_info_fields
          ? JSON.parse(user_info_fields)
          : [];
        this.setState({ inputFields: spiltInputFields });
      }
      const ip = await publicIp.v4();
      this.setState({ ipAddress: ip });
    } catch (e) {
      // console.log(e);
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.progressCount === 0 && this.state.progressCount === 1) {
      this.campaignForm.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  handleClick = (e, titleProps) => {
    const { showAndHideVideo, activeIndex } = this.state;
    showAndHideVideo[activeIndex] = true;
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    const questionId = activeIndex === index ? -1 : titleProps.questionId;
    this.setState({
      questionDescription: true,
      indexValue: titleProps.index,
      activeIndex: newIndex,
      questionId: questionId,
      showAndHideVideo,
    });
  };

  handleDurationState = (questionId, key) => {
    let element = this;
    const { videoDuration } = this.state;
    videoDuration[questionId] = this.videoPlayer[questionId].duration;
    this.setState({ videoDuration: videoDuration });
    setTimeout(function () {
      element.uploader[key].uploadFile();
    }, 0);
  };

  onUploadStart = (file, next, questionId) => {
    if (!file.type || !file.type.startsWith('video')) {
      // File is not of type "video"
      this.setState({
        modalContent: 'This file type is not supported. Please make sure the file you are uploading is a video.',
        modalIsVisible: true,
        videosUploaded: this.state.videosUploaded.filter(v => v.questionId !== questionId),
      });

      ReactGA.event({
        category: 'Video',
        action: 'Video upload type error',
        value: file.type,
      });

      return;
    }

    ReactGA.event({
      category: "Video",
      action: "Start video upload",
    });

    let videosUploaded = this.state.videosUploaded;
    videosUploaded[questionId] = file;
    this.setState(
      {
        activeIndex: -1,
        videosUploaded: videosUploaded,
        isUploadInProgress: true,
        button: true,
      },
      () => {
        const videoElement = document.getElementById(
          `video-campaign-${questionId}`
        );
        videoElement.addEventListener(
          "canplaythrough",
          (e) => {
            next(file);
            this.setState({
              progressCount: this.state.progressCount + 1,
              showSignaturePad: true,
            });
            window.scrollTo(0, document.body.scrollHeight);
          },
          { once: true }
        );
        videoElement.load();
      }
    );
  };

  onRecordedVideoUploadStart = () => {
    this.setState({ isUploadInProgress: true });
  };

  onRecordedVideoUploadEnd = () => {
    this.setState({ isUploadInProgress: false });
  };

  onUploadProgress = (e, key, questionId) => {
    let a = this.state.uploadProgress;
    if (e !== 100) {
      a[key].percent = e;
      this.setState({ uploadProgress: a });
      var uploadProgress = this.state.uploadProgress;
    } else {
      a[key].percent = e;
      this.setState({ uploadProgress: a });
      var uploadProgress = this.state.uploadProgress;
      uploadProgress.map((progress, index) => {
        if (progress.percent == 100) {
          const progressArrow = this.state.progressArrow;
          if (progressArrow.indexOf(questionId) == -1) {
            progressArrow.push(questionId);
            this.setState({ progressArrow: progressArrow });
          }
        }
      });
    }
  };

  fileUploadErrorMessage = () => {
    const text = 'Failed to upload video file.\nPlease check your internet connection and try again.';
    return (
      <section className='upload-file-error'>
        <h3>
          {text}
        </h3>
      </section>
    );
  }

  // Execute when ReactS3Uploader fails to upload the file
  // This removes the video blob from current state, in order to prevent the user
  // from moving forward with the submission if it failed to go up to S3.
  onUploadError = async (questionKey, questionId) => {
    const {
      progressArrow,
      uploadFinish,
      videoDuration,
      videoDurationError,
      videosUploaded,
      uploadProgress,
      showSignaturePad,
    } = this.state;

    if (questionId in uploadFinish) {
      this.setState({ uploadCount: this.state.uploadCount - 1 });
    } else {
      let uploader = this.uploader[questionKey];
      uploader.abort();
    }

    if (!videoDurationError[questionId]) {
      this.setState({ progressCount: this.state.progressCount - 1 });
    }

    var progressArrowIndex = progressArrow.indexOf(questionId);
    delete progressArrow[progressArrowIndex];
    delete videosUploaded[questionId];
    delete videoDuration[questionId];
    delete videoDurationError[questionId];
    delete uploadFinish[questionId];
    uploadProgress[questionKey].percent = 0;
    this.setState({
      uploadProgress,
      videoDuration,
      videoDurationError,
      uploadFinish,
      videosUploaded,
      progressArrow,
      showError: false,
      showSignaturePad: !showSignaturePad,
      processingVideo: false,
      isUploadInProgress: false,
      activeIndex: questionKey
    })

    this.msg.error(this.fileUploadErrorMessage());
  };

  onAmazonUploadStart = () => {
    this.setState({ button: false });
  };

  onFinishSelfie = (result) => {
    ReactGA.event({
      category: "Selfie",
      action: "Send selfie photo",
    });

    let filename = result.fileName;
    let ext = result.fileKey.split(".").pop();
    this.setState({ selfie_photo: filename + "." + ext });
    this.setState({ button: true });
  };

  onFinishProductPhoto = (result) => {
    ReactGA.event({
      category: "Product foto",
      action: "Send product photo",
    });

    let filename = result.fileName;
    let ext = result.fileKey.split(".").pop();
    this.setState({ product_photo: filename + "." + ext });
    this.setState({ button: true });
  };

  processVideo = async () => {
    const { dispatch, CampaignDetails } = this.props;
    const {
      fullName,
      email,
      phoneNumber,
      address,
      latitude,
      longitude,
      selfie_photo,
      product_photo,
      ipAddress,
      socialMediaHandle,
      paypalOrVenmo,
      influencerFee,
      birthDate,
      signature_photo,
      companyName,
      jobTitle,
      country,
      covidResponseLink,
      engagementTier,
      institutionName,
      starRating,
      nps,
    } = this.state;

    let params = "";
    if (this.props.location.search) {
      const res = getQueryParams(this.props.location.search);
      if (res) {
        params = JSON.stringify(res);
      }
    }

    try {
      const userData = await dispatch(getUserDetails(CampaignDetails.userId));
      const userPreferences = await dispatch(
        getUserPreferences(CampaignDetails.userId)
      );

      const sendVideoSubmitEmail =
        userPreferences && userPreferences.video_submission_email;

      this.state.uploadFinish.forEach((field, key) => {
        field.fullName = fullName;
        field.email = email;
        field.phone = phoneNumber;
        field.address = address;
        field.latitude = latitude;
        field.longitude = longitude;
        field.selfie_photo = selfie_photo;
        field.product_photo = product_photo;
        field.campaignOwnerEmail =
          userData && sendVideoSubmitEmail ? userData.email : "";
        field.userId = userData ? userData.id : "";
        field.campaignName = CampaignDetails.name;
        field.campaignOwnerName = userData ? userData.firstName : "";
        field.ipAddress = ipAddress;
        field.socialMediaHandle = socialMediaHandle;
        field.paypalOrVenmo = paypalOrVenmo;
        field.influencerFee = influencerFee;
        field.birthDate = birthDate;
        field.signature_photo = signature_photo;
        field.companyName = companyName;
        field.jobTitle = jobTitle;
        field.covidResponseLink = covidResponseLink;
        field.institutionName = institutionName;
        field.engagementTier = engagementTier;
        field.country = country;
        field.isWaterMark = userData.plan === "free" ? true : "";
        field.params = params;
        field.nps = nps;
        field.starRating = starRating;
      });

      let data = cleanArray(this.state.uploadFinish);
      data = data.map((video) => ({
        ...video,
        userBrowserInfo: extractComplete(),
      }));
      const countVideos = data.length;
      const response = await axios.post(config.AWS.GateWayURL, { videos: data });

      if (response.status === 200) {
        this.setState({ processingVideo: false });

        this.setState({ sendText: "Send" });

        const [videoData] = data;

        // check if campaign filter is already created or not. If not, create new
        if (!CampaignDetails.plugin) {
          const filterPayload = {
            name: CampaignDetails.name,
            pluginTagsId: null,
            sort: 1,
            uuid: null,
            campaignId: CampaignDetails.id,
            showVideoPeelLogo: false,
          };
          // we are creating a new filter, so passing null for id
          try {
            const savedPlugins = await dispatch(
              savePlugins(null, filterPayload)
            );
            await dispatch(getPluginsByUserId(userData.id));
            await dispatch(updateCampaignFilter(savedPlugins));
          } catch (error) {
            // TODO: discover why is creating this plugins
          }
        }

        if (CampaignDetails.user && CampaignDetails.user.klaviyoApiKey) {
          await axios
            .post(`${config.apiHost}/integrations/klaviyo-track`, {
              userId: userData.id,
              customer_email: email,
            })
            .catch((trackError) => {
              // Ignore tracker error
            });
        }
        this.setState({button: false})

        ReactGA.event({
          category: "Submit",
          action: "Video successfully processed",
        });

        this.msg.show(
          <Submission
            campaign={CampaignDetails}
            data={data}
            videoLink={`${window.location.origin}/v/${videoData.fileName}`}
          />,
          {
            type: "success",
            icon: (
              <span>
                <i aria-hidden="true" className="thanksicon checkmark big icon"></i>
              </span>
            ),
            onClose: () => {
              window.location.reload();
            },
          }
        );
        // console.log('Video has been uploaded successfully');
      } else {
        // console.log('Something went wrong! Please try again');
      }
    } catch (error) {
      this.msg.error("Error while submiting video");
    }
  };

  onSubmit = async (e) => {
    ReactGA.event({
      category: "Submit",
      action: "Send button click",
    });

    let videoDurationError = cleanArray(this.state.videoDurationError);
    if (videoDurationError.length != 0) {
      this.setState({ showError: true });
    } else if (this.state.progressCount === this.state.uploadCount) {
      this.setState({ processingVideo: true });
      await this.processVideo();
      this.setState({ processingVideo: false });
    } else {
      this.setState({ processingVideo: true });
    }
  };

  toggleChange = () => {
    if (this.state.progressCount > 0 || this.state.uploadFinish.length > 0) {
      this.state.fieldType == "hidden"
        ? this.setState({
            isChecked: true,
            fieldType: "text",
            button: true,
          })
        : this.setState({
            isChecked: false,
            fieldType: "hidden",
            button: false,
          });
    } else {
      this.setState({
        isChecked: false,
      });
    }
  };

  onUploadClick = (e, uniqueKey) => {
    const currentInputRef = this.uploadInput[uniqueKey.buttonKey];
    ReactGA.event({
      category: "Video",
      action: "Started video submission process",
    });

    // V2-451, cleanup previous value to allow user to select same file twice and
    // still trigger event handlers
    currentInputRef.value = null;
    currentInputRef.click();
  };

  onStartRecording = async () => {
    ReactGA.event({
      category: "Video",
      action: "Started video submission process",
    });
    ReactGA.event({
      category: "Video",
      action: "Choose to record video",
    });

    try {
      const { isRecordOrUploadVideo, startRecording, activeIndex } = this.state;

      const constraints = {
        audio: true,
        video: {
          facingMode: "user",
          width: { min: 640, ideal: 1280, max: 1920 },
          height: { min: 480, ideal: 720, max: 1080 },
        },
      };

      await navigator.mediaDevices.getUserMedia(constraints);

      isRecordOrUploadVideo[activeIndex] = false;
      startRecording[activeIndex] = true;
      this.setState({
        isRecordOrUploadVideo,
        startRecording,
        reRender: true,
      });
    } catch (err) {
      this.setState({ isWebCamOrNot: false });
      this.msg.show("Your media device is not connected.", {
        time: 10000,
      });
    }
  };

  onCancelRecord = () => {
    ReactGA.event({
      category: "Video",
      action: "Choose to cancel record video",
    });

    const { isRecordOrUploadVideo, startRecording, activeIndex } = this.state;

    isRecordOrUploadVideo[activeIndex] = true;
    startRecording[activeIndex] = false;
    this.setState({
      isRecordOrUploadVideo,
      startRecording,
      reRender: true,
    });
  };

  onUploadFinish = (e, questionId) => {
    ReactGA.event({
      category: "Video",
      action: "Finished video upload",
    });

    const { CampaignDetails } = this.props;
    if (CampaignDetails.isSignatureRequire) {
      this.setState({
        button: true,
      });
    }
    const { uploadFinish } = this.state;
    const formatedObjectForProcessVideo = {
      videoId: e.videoId,
      path: e.publicUrl,
      questionId: questionId,
      campaignId: this.props.CampaignDetails.id,
      fileName: e.fileName,
      fileType: e.fileType,
      fullName: "",
      email: "",
      phone: "",
      address: "",
      selfie_photo: "",
      product_photo: "",
      socialMediaHandle: "",
      paypalOrVenmo: "",
      influencerFee: "",
      birthDate: "",
      signature_photo: "",
      videoSubmissionType: VIDEO_SUBMISSION_TYPE.FILE_UPLOAD,
    };
    uploadFinish[questionId] = [];
    uploadFinish[questionId] = formatedObjectForProcessVideo;
    this.setState({
      uploadCount: this.state.uploadCount + 1,
      isUploadInProgress: false,
    });

    if (this.state.processingVideo) {
      if (this.state.progressCount === this.state.uploadCount) {
        this.processVideo();
      }
    }
  };

  onRetakeClick = (questionId, key) => {
    const currentInputRef = this.uploadInput[key];
    ReactGA.event({
      category: "Video",
      action: "Retake video",
    });

    this.onDeleteClick(questionId, key);
    currentInputRef.value = null;
    currentInputRef.click();
  };

  onDeleteClick = (questionId, key) => {
    ReactGA.event({
      category: "Video",
      action: "Delete video",
    });

    const { dispatch } = this.props;
    const {
      progressArrow,
      uploadFinish,
      videoDuration,
      videoDurationError,
      videosUploaded,
      uploadProgress,
      showSignaturePad,
    } = this.state;
    if (questionId in uploadFinish) {
      const FileKey = uploadFinish[questionId].path;
      let delObj = {
        key: FileKey,
      };
      dispatch(deleteS3Video(delObj));
      this.setState({ uploadCount: this.state.uploadCount - 1 });
    } else {
      let uploader = this.uploader[key];
      uploader.abort();
    }
    if (!videoDurationError[questionId]) {
      this.setState({ progressCount: this.state.progressCount - 1 });
    }
    var progressArrowIndex = progressArrow.indexOf(questionId);
    delete progressArrow[progressArrowIndex];
    delete videosUploaded[questionId];
    delete videoDuration[questionId];
    delete videoDurationError[questionId];
    delete uploadFinish[questionId];
    uploadProgress[key].percent = 0;
    this.setState({ uploadProgress: uploadProgress });
    this.setState({ videoDuration: videoDuration });
    this.setState({ videoDurationError: videoDurationError });
    this.setState({ uploadFinish: uploadFinish });
    this.setState({ videosUploaded: videosUploaded });
    this.setState({ progressArrow: progressArrow });
    this.setState({
      showError: false,
      showSignaturePad: !showSignaturePad,
    });
  };

  handleModalClose = () => {
    this.setState({ modalContent: null, modalIsVisible: false });
  };

  updateCampaignCounts = (id) => {
    const { dispatch } = this.props;
    let obj = { id: id };
    const result = dispatch(updateCampaignCount(obj));
    this.setState({ updateCount: false });
  };

  handleOnChange = (key, value) => {
    this.setState({ [key]: value });
  };

  handleGoogleAddress = (key, address, lat, lng) => {
    if (key === "country") {
      return this.setState({ country: address });
    }

    this.setState({ address: address, latitude: lat, longitude: lng });
  };

  trim = () => {
    ReactGA.event({
      category: "Signature",
      action: "Save signature",
    });

    const { dispatch, CampaignDetails } = this.props;
    const imageDATA = this.signaturePad.toDataURL("image/png");
    const isEmpty = this.signaturePad.isEmpty();
    if (!isEmpty) {
      this.setState({ uploadSignaturePhoto: true });
      let data = {
        imageDATA: imageDATA,
        campaignID: CampaignDetails.id,
      };
      const result = dispatch(updateSignaturePic(data));
      result
        .then((data, error) => {
          let filename = data.fileName;
          let ext = data.fileKey.split(".").pop();
          this.setState({
            signature_photo: filename + "." + ext,
            uploadSignaturePhoto: false,
            changeButtonColor: true,
          });
        })
        .catch(function (error) {
          // console.log(error);
        });
    } else {
      this.msg.show("Your signature is required.", {
        time: 3000,
      });
    }
  };

  clear = () => {
    ReactGA.event({
      category: "Signature",
      action: "Clear signature",
    });

    this.signaturePad.clear();
    this.setState({ changeButtonColor: false, signature_photo: "" });
  };

  onUploadRecordVideo = (e, questionId, uniqueWebKey, videoUrl) => {
    ReactGA.event({
      category: "Video",
      action: "Upload record video",
    });

    const { startRecording, activeIndex } = this.state;
    startRecording[activeIndex] = false;
    const { CampaignDetails } = this.props;

    if (CampaignDetails.isSignatureRequire) {
      this.setState({
        button: true,
      });
    }

    let a = this.state.uploadProgress;
    a[uniqueWebKey].percent = 100;
    this.setState({ uploadProgress: a });
    const progressArrow = this.state.progressArrow;
    const { uploadFinish } = this.state;
    const formatedObjectForProcessVideo = {
      videoId: e.videoId,
      path: e.publicUrl,
      questionId: questionId,
      campaignId: CampaignDetails.id,
      fileName: e.fileName,
      fileType: e.fileType,
      url: e.signedUrl,
      fullName: "",
      email: "",
      phone: "",
      address: "",
      selfie_photo: "",
      product_photo: "",
      socialMediaHandle: "",
      paypalOrVenmo: "",
      influencerFee: "",
      birthDate: "",
      signature_photo: "",
      videoSubmissionType: VIDEO_SUBMISSION_TYPE.RECORDING,
    };
    uploadFinish[questionId] = [];
    uploadFinish[questionId] = formatedObjectForProcessVideo;
    this.setState({
      uploadCount: this.state.uploadCount + 1,
      activeIndex: -1,
    });

    if (progressArrow.indexOf(questionId) == -1) {
      progressArrow.push(questionId);
      this.setState({
        progressArrow: progressArrow,
        startRecording,
        progressCount: this.state.progressCount + 1,
        showSignaturePad: true,
        reRender: false,
        videosUploaded: {
          ...this.state.videosUploaded,
          [questionId]: videoUrl,
        },
      });
    }
  };

  onRecordVideo = () => {
    const { isRecordOrUploadVideo, startRecording, activeIndex } = this.state;

    isRecordOrUploadVideo[activeIndex] = true;
    startRecording[activeIndex] = false;
    this.setState({
      isRecordOrUploadVideo,
      startRecording,
      reRender: false,
    });
    this.onStartRecording();
  };

  onUploadVideoError = (showMsg = true) => {
    this.setState({ isUploadInProgress: false });
    if (showMsg) {
      this.msg.show("Something went wrong. Please try again", {
        time: 5000,
      });
    }
  };

  playVideo = () => {
    ReactGA.event({
      category: "Video",
      action: "Play video",
    });

    let video = document.getElementById(`playVideo`);
    video.controls = true;
    this.setState({
      videoAutoPlay: true,
      showAndHidePlayButton: false,
    });
    video.play();
  };

  validateSignatureField() {
    const signatureNotRequired = !this.props.CampaignDetails.isSignatureRequire;
    if (signatureNotRequired) {
      return true;
    }

    return !!this.state.signature_photo.length;
  }

  checkTerms(campaignDetails) {
      return campaignDetails.isSignatureRequire || this.state.isChecked
  }

  checkSignature(campaginDetails) {
    return !campaginDetails || !campaginDetails.isSignatureRequire || !!this.state.signature_photo.length
  }

  checkFormFields(user_info_fields){
    const {
      fullName,
      email,
      phoneNumber,
      address,
      selfie_photo,
      product_photo,
      socialMediaHandle,
      paypalOrVenmo,
      influencerFee,
      birthDate,
      companyName,
      jobTitle,
      country,
      covidResponseLink,
      engagementTier,
      institutionName,
      starRating,
      nps,
    } = this.state;

    const fieldsValue = {
      Name: fullName,
      Email: email,
      Address: address,
      Phone: phoneNumber,
      "Selfie Photo": selfie_photo,
      "Product Photo": product_photo,
      "Company/Organization Name": companyName,
      "Job Title": jobTitle,
      "Birth Date (ex: Jan. 3, 1982)": birthDate,
      "Social Media Handle": socialMediaHandle,
      "Star Ratings": starRating,
      NPS: nps,
      "PayPal or Venmo": paypalOrVenmo,
      "Influencer Fee": influencerFee,
      Country: country,
      "Link to Your Company's Response to COVID-19": covidResponseLink,
      "Engagement Tier": engagementTier,
      "Institution Name": institutionName,
    };

    let formFilled = true;
    if (user_info_fields) {
      formFilled = JSON.parse(user_info_fields).reduce(
        (acc, curr) => acc && fieldsValue[curr],
        formFilled
      );
    }

    return !user_info_fields || formFilled;
  }

  checkRequiredFields() {
    const { CampaignDetails } = this.props;
    let isFormComplete = true;

    if (
      !this.checkTerms(CampaignDetails) ||
      !this.checkSignature(CampaignDetails) ||
      !this.checkFormFields(CampaignDetails && CampaignDetails.user_info_fields)
    ) {
      isFormComplete = false;
    }

    return isFormComplete;
  }

  handleEmailBlur = (e) => {
    this.setState({email: e.target.value});
  };

  render() {
    const { handleSubmit, CampaignDetails, errorMessage, match } = this.props;
    const {
      reRender,
      uploadProgress,
      inputFields,
      showSignaturePad,
      isRecordOrUploadVideo,
      showAndHideVideo,
      startRecording,
      button,
      changeButtonColor,
      processingVideo,
      showError,
      progressCount,
      uploadSignaturePhoto,
      fullName,
      email,
      phoneNumber,
      birthDate,
      paypalOrVenmo,
      socialMediaHandle,
      influencerFee,
      companyName,
      jobTitle,
      covidResponseLink,
      institutionName,
      selfie_photo,
      product_photo,
      nps,
      starRating,
      isUploadInProgress,
    } = this.state;

    if (errorMessage && errorMessage.statusCode === 400)
      return <Redirect to={APP_ROUTES.notFound} />;

    if (!CampaignDetails) return null;

    const {
      campaignTemplateType,
      banner,
      type,
      nameAuth,
      designation,
      logoAuth,
      profileImage,
      imageCampaign,
      videoCampaign,
      description,
      videos,
      maxVideos,
      expiryTime,
      campaignQuestions,
      isSignatureRequire,
      privacy_policy,
      terms_conditions,
    } = CampaignDetails;

    const SiteAssets = config.AWS.SiteAssets;
    const currentTime = moment();
    const isFormComplete = this.checkRequiredFields();
    const isButtonDisabled = !isFormComplete || !button || isUploadInProgress;

    let videoPath;
    if (videoCampaign) {
      videoPath = `${SiteAssets}/${videoCampaign}`
        .replace("original", "transcoded")
        .replace(/\.[a-z0-9]{3,4}$/i, ".mp4");
    }

    const titleStyle = { color: 'black' };
    const buttonStyle = {
      background: banner || CAMPAIGN_COLOR,
      color: (banner && getContrast(banner)) || COLORS.white,
    };

    const expiredCampaign =
      !!expiryTime && currentTime.isAfter(moment(expiryTime));

    const videoLimitReached =
      !!maxVideos && videos && videos.length >= maxVideos;

    return (
      <div className="splash-wrapper">
        <div>
          {!expiredCampaign && !videoLimitReached && (
            <BoundaryWarning campaignDetails={CampaignDetails} />
          )}

          <div
            className="background-top"
            style={{ background: banner || CAMPAIGN_COLOR }}
          />

          <div className="splash-main">
            <header className="splash-header">
              {CAMPAIGN_TYPE_VALUE[campaignTemplateType] === "PERSONALIZED" && (
                <Image
                  className="splashuser"
                  centered
                  src={
                    profileImage
                      ? type === 0
                        ? assetsUrl(profileImage)
                        : profileImage
                      : Images.splashuser
                  }
                />
              )}

              <LogoRow
                title={nameAuth}
                subTitle={designation}
                campaignType={campaignTemplateType}
                logoPath={logoAuth && assetsUrl(getOriginalImg(logoAuth))}
              />

              {CAMPAIGN_TYPE_VALUE[campaignTemplateType] === "VIDEO" && (
                <Video
                  className="videoPlayer"
                  source={videoCampaign ? videoPath : campaignImage}
                />
              )}

              {CAMPAIGN_TYPE_VALUE[campaignTemplateType] === "IMAGE" && (
                <Image
                  className="imageCampaign"
                  src={imageCampaign ? assetsUrl(imageCampaign) : campaignImage}
                />
              )}

              {description && (
                <p className="Maindisc">
                  {config.campaignIDs.includes(match.params.id)
                    ? htmlToReactParser.parse(description)
                    : renderHTML(description)}
                </p>
              )}
            </header>

            {!expiredCampaign && !videoLimitReached && (
              <div>
                {!this.isRecordingSupported && !isIPad && (
                  <section className="splash-section-warning">
                    <RecordNotSupportedMessage />
                  </section>
                )}

                <section>
                  <h1 className="section-title" style={titleStyle}>
                    1. UPLOAD YOUR VIDEO
                  </h1>

                  {campaignQuestions.map((question, key) => (
                    <Accordion
                      questionKey={key}
                      questionId={this.state.questionId}
                      activeIndex={this.state.activeIndex}
                      question={question}
                      campaignColor={CampaignDetails.banner || COLORS.default}
                      uploadProgress={uploadProgress}
                      handleDeleteVideo={this.onDeleteClick}
                      handleRetakeVideo={this.onRetakeClick}
                      handleStartRecording={this.onStartRecording}
                      handleUploadVideo={this.onUploadClick}
                      handleUploadRecordVideo={this.onUploadRecordVideo}
                      handleUploadFinish={this.onUploadFinish}
                      handleRecordVideo={this.onRecordVideo}
                      handleUploadVideoError={this.onUploadVideoError}
                      handleUploadStart={this.onUploadStart}
                      handleUploadProgress={this.onUploadProgress}
                      handleOnCancelRecord={this.onCancelRecord}
                      uploadError={this.onUploadError}
                      handleAccordion={this.handleClick}
                      videoDurationError={this.state.videoDurationError}
                      videosUploaded={this.state.videosUploaded}
                      recordVideosUploaded={this.state.uploadFinish}
                      uploader={this.uploader}
                      uploadInput={this.uploadInput}
                      showAndHideVideo={showAndHideVideo}
                      progressArrow={this.state.progressArrow}
                      isRecordOrUploadVideo={isRecordOrUploadVideo}
                      startRecording={startRecording}
                      reRender={reRender}
                      videoDuration={this.state.videoDuration}
                      videoPlayer={this.videoPlayer}
                      isRecordingSupported={this.isRecordingSupported}
                      onRecordedVideoUploadStart={
                        this.onRecordedVideoUploadStart
                      }
                      onRecordedVideoUploadEnd={
                        this.onRecordedVideoUploadEnd
                      }
                    />
                  ))}

                  {showError && (
                    <div className="content">
                      <div className="videoerror">
                        Please fix the errors above.
                      </div>
                    </div>
                  )}
                </section>

                {progressCount > 0 && (
                  <section ref={this.campaignForm} className="splash-section">
                    <h1 className="section-title" style={titleStyle}>
                      2. FILL OUT THE FORM
                    </h1>

                    <TermsArea
                      isSignatureRequire={isSignatureRequire}
                      campaignColor={buttonStyle.background}
                      isChecked={this.state.isChecked}
                      handleCheck={this.toggleChange}
                      privacyPolicy={privacy_policy}
                      termsConditions={terms_conditions}
                    />

                    {isSignatureRequire && showSignaturePad && (
                      <SignatureArea
                        isSigned={changeButtonColor}
                        loading={uploadSignaturePhoto}
                        buttonStyle={buttonStyle}
                        handleSave={this.trim}
                        handleClear={this.clear}
                        refSignaturePad={(ref) => (this.signaturePad = ref)}
                      />
                    )}

                    <Form
                      className='formStyle'
                      onSubmit={this.onSubmit}
                    >
                      {!!inputFields && !!inputFields.length && (
                        <CampaignForm
                          inputFields={inputFields}
                          handleOnChange={this.handleOnChange}
                          handleGoogleAddress={this.handleGoogleAddress}
                          campaignColor={buttonStyle.background}
                          campaignId={CampaignDetails.id}
                          onAmazonUploadStart={this.onAmazonUploadStart}
                          onFinishProductPhoto={this.onFinishProductPhoto}
                          onFinishSelfie={this.onFinishSelfie}
                          values={{
                            fullName,
                            email,
                            phoneNumber,
                            birthDate,
                            paypalOrVenmo,
                            socialMediaHandle,
                            influencerFee,
                            companyName,
                            jobTitle,
                            covidResponseLink,
                            institutionName,
                            nps,
                            starRating,
                            selfie_photo,
                            product_photo,
                          }}
                        />
                      )}

                      <h1 className="section-title" style={titleStyle}>
                        3. CLICK SEND
                      </h1>
                      <Button
                        className="send"
                        size="large"
                        disabled={isButtonDisabled}
                        style={buttonStyle}
                        loading={processingVideo || isUploadInProgress}
                        content="Send"
                      />
                      {processingVideo && (
                        <p className="send-warning">
                          We're processing your video.
                        </p>
                      )}
                    </Form>
                  </section>
                )}
              </div>
            )}

            {(expiredCampaign || videoLimitReached) && (
              <p className="expired-msg">
                We're sorry, but this campaign has expired.
              </p>
            )}

            <div className="ui splashbox thanksAlert">
              <AlertContainer
                ref={(a) => (this.msg = a)}
                {...this.alertOptions}
              />
            </div>
          </div>
        </div>

        <Footer
          campaign={CampaignDetails}
          campaignColor={CampaignDetails.banner}
          urlTextColor={buttonStyle.color}
        />

        <AlertModal
          isVisible={this.state.modalIsVisible}
          content={this.state.modalContent}
          onClose={this.handleModalClose}
        />

        {!isPreview(this.props.location.search) &&
          this.state.updateCount &&
          this.updateCampaignCounts(CampaignDetails.id)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    CampaignDetails: state.get('splash').get('Questions'),
    Splash: state.get('splash').get('Splash'),
    loading: state.get('splash').get('loading'),
    errorMessage: state.get('splash').get('errorMessage'),
  };
}

export default connect(mapStateToProps)(Splash);



// WEBPACK FOOTER //
// ./src/containers/Splash/Splash.js